// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"32434a8b","667":"174faed4"}[chunkId] + ".chunk.js";
};